// src/client/contact-form.ts
export class ContactFormController {
    private readonly form: HTMLFormElement;

    constructor(form: HTMLFormElement) {
        this.form = form;
    }

    public init(): void {
        this.form.addEventListener('submit', (e) => {
            void this.handleSubmit(e);
        });
        this.clearErrorsOnInput();
    }

    private clearErrorsOnInput(): void {
        const inputs = this.form.querySelectorAll('input, select, textarea');
        inputs.forEach((input) => {
            input.addEventListener('input', () => {
                input.classList.remove('border-red-600', 'bg-red-50');
                // Could also hide error messages if we had them targeted
            });
        });
    }

    private async handleSubmit(e: Event): Promise<void> {
        e.preventDefault();
        const submitBtn = this.form.querySelector('button[type="submit"]');
        if (!submitBtn || !(submitBtn instanceof HTMLButtonElement)) return;

        const originalText = this.setSubmittingState(submitBtn);

        try {
            const formData = new FormData(this.form);
            const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

            const response = await fetch('/contact/submit', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    ...(csrfToken ? { 'X-CSRF-Token': csrfToken } : {}),
                },
                body: formData
            });

            if (!response.ok) {
                // Try to parse error message
                let errorMsg = 'Er ging iets mis. Probeer het opnieuw.';
                try {
                    const data = (await response.json()) as { error?: string };
                    if (data.error) {
                         errorMsg = data.error;
                    }
                } catch {
                     // ignore json parse error
                }
                throw new Error(errorMsg);
            }

            const data = (await response.json()) as { redirect?: string };
            
            // Success
            this.showSuccessMessage();
            setTimeout(() => {
                globalThis.location.href = data.redirect ?? '/bedankt';
            }, 500);

        } catch (error) {
            console.error('Contact form error:', error);
            this.showSubmitError(error instanceof Error ? error.message : undefined);
            this.resetSubmitButton(submitBtn, originalText);
        }
    }

    private setSubmittingState(submitBtn: HTMLButtonElement): string {
        const originalText = submitBtn.innerHTML;
        submitBtn.disabled = true;
        submitBtn.innerHTML = `
            <div class="flex items-center gap-2">
                <svg class="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Verzenden...
            </div>
        `;
        return originalText;
    }

    private resetSubmitButton(submitBtn: HTMLButtonElement, originalText: string): void {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
    }

    private showSuccessMessage(): void {
        // Optional: show a toast or banner before redirect
    }

    private showSubmitError(message = 'Er ging iets mis. Controleer uw invoer.'): void {
        // Simple alert or banner
        alert(message);
    }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
    const section = document.getElementById('contact-form');
    const form = section?.querySelector('form');

    if (form instanceof HTMLFormElement) {
        const controller = new ContactFormController(form);
        controller.init();
    }
});
